/**
 * providerPortalRules - Regras de exibição das ações do prestador no Portal.
 *
 * Espelha a lista fechada de `_provider_portal_exec` (o banco é a validação real):
 *  - Iniciar: OS aberta ou agendada.
 *  - Pausar/Retomar e Concluir: OS em andamento.
 *  - Concluir correção: OS em correção, SEM troca de equipamento (troca é do gestor).
 *  - Andamento: OS não concluída nem cancelada.
 *
 * RELEASE: 2026-10-12 v1.1.0 - Jornada premium: ação principal contextual considera
 *            deslocamento, check-in e início efetivo do serviço.
 * RELEASE: 2026-10-12 v1.0.0 - Versão inicial (Fase 3).
 */
export type ProviderAction = 'start' | 'pause' | 'resume' | 'conclude' | 'conclude_correction' | 'comment';

export type ProviderJourneyAction = 'travel_start' | 'check_in' | 'start' | 'resume' | 'continue' | 'review' | 'done';

interface JourneyState {
  status: string;
  isPaused: boolean;
  travelStartedAt?: string | null;
  checkedInAt?: string | null;
  checklistsTotal?: number;
  checklistsCompleted?: number;
}

/** Resolve a única ação principal exibida no rodapé do detalhe. */
export function providerJourneyAction(state: JourneyState): ProviderJourneyAction {
  if (state.status === 'completed' || state.status === 'cancelled') return 'done';
  if (state.status === 'awaiting_review') return 'review';
  if (state.isPaused) return 'resume';
  if (state.status === 'open' || state.status === 'scheduled') {
    if (!state.travelStartedAt) return 'travel_start';
    if (!state.checkedInAt) return 'check_in';
    return 'start';
  }
  if (state.status === 'in_progress' || state.status === 'in_correction') return 'continue';
  return 'done';
}

/** Ações disponíveis ao prestador para a situação atual da OS. */
export function providerActionsFor(status: string, isPaused: boolean): ProviderAction[] {
  const actions: ProviderAction[] = [];
  if (status === 'open' || status === 'scheduled') actions.push('start');
  if (status === 'in_progress') {
    actions.push(isPaused ? 'resume' : 'pause');
    if (!isPaused) actions.push('conclude');
  }
  if (status === 'in_correction') actions.push('conclude_correction');
  if (status !== 'completed' && status !== 'cancelled') actions.push('comment');
  return actions;
}

/** Concluir correção nunca envia equipamentos (decisão do gestor). */
export function correctionPayload(note?: string) {
  return { note: note?.trim() || undefined };
}
